// BCPO Nipple Cover Colour - Add color squares to dropdown options
(function() {
  'use strict';

  // Color mapping for Nipple Cover Colour
  const colorMap = {
    'beige': 'rgb(245, 245, 220)',
    'brown': 'rgb(139, 69, 19)',
    'black': 'rgb(0, 0, 0)',
    'honey': 'rgb(240, 230, 140)'
  };

  function addColorSquaresToDropdown() {
    // Check if we're on the Confidence Bundle page
    const isConfidenceBundle = window.location.pathname.includes('/products/snatchd-bundle') || 
                               document.querySelector('[data-product-handle="snatchd-bundle"]') ||
                               (document.querySelector('body') && document.querySelector('body').classList.contains('template-product') && 
                                window.location.href.includes('snatchd-bundle'));
    
    // Find all BCPO selects
    const selects = document.querySelectorAll('select.single-option-selector');
    
    selects.forEach(function(select) {
      // Identify which color selector this is
      const ariaLabel = select.getAttribute('aria-label') || '';
      const labelText = ariaLabel.toLowerCase();
      const isNippleCoverColour = (labelText.includes('nipple') && labelText.includes('cover')) &&
                                   (labelText.includes('colour') || labelText.includes('color'));
      const isShapeTapeColour = (labelText.includes('shape') && labelText.includes('tape')) &&
                                 (labelText.includes('colour') || labelText.includes('color'));
      
      if (isNippleCoverColour || isShapeTapeColour) {
        // Skip if already processed
        if (select.dataset.colorsAdded === 'true') return;
        select.dataset.colorsAdded = 'true';
        
        // Get wrapper
        const wrapper = select.closest('.selector-wrapper.bcpo-default') || select.parentElement;
        
        // Create custom dropdown container
        const customDropdown = document.createElement('div');
        customDropdown.className = 'bcpo-color-dropdown';
        customDropdown.style.cssText = 'position: relative; width: 100%; max-width: 420px;';
        
        // Get all options, keep any "Choose one" entry even if disabled/empty
        let options = Array.from(select.options).filter(function(opt) {
          const text = (opt.textContent || '').trim().toLowerCase();
          if (text === 'choose one' || text === 'choose' || opt.value === '') return true;
          return opt.value && !opt.disabled;
        });
        
        // Ensure we have a "Choose one" option at the top
        const hasChooseOne = options.some(function(opt) {
          const text = (opt.textContent || '').trim().toLowerCase();
          return text === 'choose one' || text === 'choose' || opt.value === '';
        });
        if (!hasChooseOne) {
          const chooseOpt = new Option('Choose one', '');
          chooseOpt.disabled = true;
          options.unshift(chooseOpt);
        }
        
        // On Confidence Bundle page, filter out "black" option only for Nipple Cover Colour
        if (isConfidenceBundle && isNippleCoverColour) {
          options = options.filter(function(opt) {
            return opt.value.toLowerCase().trim() !== 'black';
          });
        }
        
        // Always start at blank so the custom control shows "Choose one"
        let currentValue = '';
        select.value = '';

        const currentOption = options.find(function(opt) {
          return opt.value === currentValue;
        }) || options[0];
        
        // Create button
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bcpo-color-dropdown-button';
        button.style.cssText = 'width: 100%; height: 48px; padding: 10px 40px 10px 12px; border: 1.5px solid #000; border-radius: 0; background: #fff; color: #000; font-size: 15px; font-family: var(--font-body-family, "Playfair Display", serif); text-align: left; cursor: pointer; display: flex; align-items: center; position: relative; box-sizing: border-box;';
        
        // Create color square for button (only when an actual color is selected)
        let buttonSquare = null;
        if (currentOption && currentOption.value !== '') {
          const buttonColor = colorMap[currentOption.value.toLowerCase().trim()] || 'rgb(200, 200, 200)';
          buttonSquare = document.createElement('div');
          buttonSquare.className = 'bcpo-color-square';
          buttonSquare.style.cssText = 'width: 1.2rem; height: 1.2rem; border-radius: 50%; border: 0.1rem solid rgba(0, 0, 0, 0.15); background: ' + buttonColor + '; margin-right: 0.8rem; flex-shrink: 0;';
        }
        
        // Create text
        const buttonText = document.createElement('span');
        buttonText.textContent = currentOption && currentOption.value !== '' ? currentOption.value : 'Choose one';
        buttonText.style.cssText = 'flex: 1;';
        
        // Create arrow
        const arrow = document.createElement('span');
        arrow.innerHTML = '▼';
        arrow.style.cssText = 'position: absolute; right: 14px; top: 50%; transform: translateY(-50%); font-size: 10px; pointer-events: none;';
        
        if (buttonSquare) button.appendChild(buttonSquare);
        button.appendChild(buttonText);
        button.appendChild(arrow);
        
        // Create menu
        const menu = document.createElement('div');
        menu.className = 'bcpo-color-dropdown-menu';
        menu.style.cssText = 'position: absolute; top: 100%; left: 0; right: 0; background: #fff; border: 1.5px solid #000; border-top: none; z-index: 10000; max-height: 200px; overflow-y: auto; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); margin-top: -1px;';
        
        // Create menu items
        if (options.length === 0) {
          console.warn('No options found for Nipple Cover Colour dropdown');
        }
        
        options.forEach(function(option) {
          const item = document.createElement('div');
          item.className = 'bcpo-color-dropdown-item';
          item.dataset.value = option.value;
          const isPlaceholder = option.value === '';
          item.style.cssText = 'padding: 10px 12px; cursor: ' + (isPlaceholder ? 'not-allowed' : 'pointer') + '; display: flex; align-items: center; border-bottom: 1px solid rgba(0, 0, 0, 0.1); transition: background-color 0.2s; ' + (isPlaceholder ? 'color: #999;' : '');
          
          // Color square (skip for placeholder)
          let itemSquare = null;
          if (!isPlaceholder) {
            const optionValueLower = option.value.toLowerCase().trim();
            const itemColor = colorMap[optionValueLower] || 'rgb(200, 200, 200)';
            itemSquare = document.createElement('div');
            itemSquare.className = 'bcpo-color-square';
            itemSquare.style.cssText = 'width: 1.2rem; height: 1.2rem; border-radius: 50%; border: 0.1rem solid rgba(0, 0, 0, 0.15); background: ' + itemColor + '; margin-right: 0.8rem; flex-shrink: 0;';
            item.appendChild(itemSquare);
          }
          
          // Text
          const itemText = document.createElement('span');
          itemText.textContent = option.value === '' ? 'Choose One' : option.value;
          itemText.style.cssText = 'flex: 1;';
          
          item.appendChild(itemText);
          
          if (!isPlaceholder) {
            // Hover effect
            item.addEventListener('mouseenter', function() {
              this.style.backgroundColor = '#f5f5f5';
            });
            item.addEventListener('mouseleave', function() {
              this.style.backgroundColor = '#fff';
            });
          } else {
            item.style.pointerEvents = 'none'; // disabled placeholder
          }
          
          // Click handler - will be updated after hidden input is created
          if (!isPlaceholder) {
            item.addEventListener('click', function(e) {
              e.stopPropagation();
              e.preventDefault();
              const selectedValue = this.dataset.value;
              
              // Update button swatch/text
              if (selectedValue === '') {
                // remove swatch if present
                if (buttonSquare && buttonSquare.parentNode) {
                  buttonSquare.parentNode.removeChild(buttonSquare);
                }
                buttonSquare = null;
                buttonText.textContent = 'Choose one';
              } else {
                const newColor = colorMap[selectedValue.toLowerCase().trim()] || 'rgb(200, 200, 200)';
                if (!buttonSquare) {
                  buttonSquare = document.createElement('div');
                  buttonSquare.className = 'bcpo-color-square';
                  buttonSquare.style.cssText = 'width: 1.2rem; height: 1.2rem; border-radius: 50%; border: 0.1rem solid rgba(0, 0, 0, 0.15); background: ' + newColor + '; margin-right: 0.8rem; flex-shrink: 0;';
                  button.insertBefore(buttonSquare, buttonText);
                } else {
                  buttonSquare.style.background = newColor;
                }
                buttonText.textContent = selectedValue;
              }
              
              // Close menu
              menu.classList.remove('show');
              button.setAttribute('aria-expanded', 'false');
            });
          }
          
          menu.appendChild(item);
        });
        
        // Toggle menu (closing any other open color dropdowns first)
        button.addEventListener('click', function(e) {
          e.stopPropagation();
          e.preventDefault();
          const isOpen = menu.classList.contains('show');
          
          // Close all other open color dropdown menus
          document.querySelectorAll('.bcpo-color-dropdown-menu.show').forEach(function(openMenu) {
            if (openMenu !== menu) {
              openMenu.classList.remove('show');
              const btn = openMenu.closest('.bcpo-color-dropdown')?.querySelector('.bcpo-color-dropdown-button');
              if (btn) btn.setAttribute('aria-expanded', 'false');
            }
          });

          if (isOpen) {
            menu.classList.remove('show');
            button.setAttribute('aria-expanded', 'false');
          } else {
            menu.classList.add('show');
            button.setAttribute('aria-expanded', 'true');
          }
        });
        
        // Close on outside click
        document.addEventListener('click', function(e) {
          if (!customDropdown.contains(e.target)) {
            menu.classList.remove('show');
            button.setAttribute('aria-expanded', 'false');
          }
        });
        
        // Prevent menu clicks from closing
        menu.addEventListener('click', function(e) {
          e.stopPropagation();
        });
        
        // Create hidden input to replace select for form submission
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = select.name;
        hiddenInput.id = select.id;
        hiddenInput.value = currentValue; // empty by default to enforce "Choose one"
        if (select.hasAttribute('required')) {
          hiddenInput.setAttribute('required', '');
        }
        if (select.getAttribute('data-option')) {
          hiddenInput.setAttribute('data-option', select.getAttribute('data-option'));
        }
        hiddenInput.setAttribute('aria-label', select.getAttribute('aria-label') || '');
        
        // Assemble
        customDropdown.appendChild(button);
        customDropdown.appendChild(menu);
        
        // Update all menu item click handlers to also update hidden input
        menu.querySelectorAll('.bcpo-color-dropdown-item').forEach(function(item) {
          // Add a new click handler that runs first (capture phase) to update hidden input
          item.addEventListener('click', function(e) {
            const selectedValue = this.dataset.value;
            hiddenInput.value = selectedValue;
            
            // Trigger change event on hidden input (for BCPO compatibility)
            const changeEvent = new Event('change', { bubbles: true });
            hiddenInput.dispatchEvent(changeEvent);
            
            // Also trigger input event
            const inputEvent = new Event('input', { bubbles: true });
            hiddenInput.dispatchEvent(inputEvent);
          }, true); // Use capture phase to run before the existing handler
        });
        
        // Insert hidden input and custom dropdown before select
        select.parentNode.insertBefore(hiddenInput, select);
        select.parentNode.insertBefore(customDropdown, select);
        
        // Remove original select element completely
        select.remove();
      }
    });
  }

  // Ensure size dropdowns default to "Choose one" (Nipple Cover Size, Shape Tape Size)
  function setSizeDropdownDefaults() {
    const sizeSelects = document.querySelectorAll('select.single-option-selector');
    if (!sizeSelects.length) return;

    sizeSelects.forEach(function(select) {
      const ariaLabel = (select.getAttribute('aria-label') || '').toLowerCase();
      const isNippleCoverSize = ariaLabel.includes('nipple') && ariaLabel.includes('cover') && ariaLabel.includes('size');
      const isShapeTapeSize = ariaLabel.includes('shape') && ariaLabel.includes('tape') && ariaLabel.includes('size');
      if (!isNippleCoverSize && !isShapeTapeSize) return;

      // Add/ensure "Choose one" option
      let chooseOpt = null;
      Array.from(select.options).forEach(function(opt) {
        const text = (opt.textContent || '').trim().toLowerCase();
        if (text === 'choose one' || text === 'choose' || opt.value === '') {
          chooseOpt = opt;
        }
      });
      if (!chooseOpt) {
        chooseOpt = new Option('Choose one', '');
        chooseOpt.disabled = true;
        select.insertBefore(chooseOpt, select.firstChild);
      } else {
        chooseOpt.disabled = true;
      }

      // Force default selection to "Choose one"
      select.value = '';
      chooseOpt.selected = true;

      const changeEvent = new Event('change', { bubbles: true });
      select.dispatchEvent(changeEvent);
    });
  }

  // Initialize
  function init() {
    addColorSquaresToDropdown();
    setSizeDropdownDefaults();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Run after delays for dynamic content
  setTimeout(init, 500);
  setTimeout(init, 1000);
  setTimeout(init, 2000);
  setTimeout(init, 3000);
  window.addEventListener('load', init);
  
  // Watch for new elements
  const observer = new MutationObserver(function() {
    setTimeout(function() {
      addColorSquaresToDropdown();
      setSizeDropdownDefaults();
    }, 100);
  });
  
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

